import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { LogoIcon } from 'assets';
import { flexCenter } from 'styles';

function Logo({ sx }) {
  return (
    <Box className="logo" sx={{ ...flexCenter, ...sx }}>
      <LogoIcon width={'4em'} />
    </Box>
  );
}

Logo.propTypes = {
  sx: PropTypes.object,
};
export default Logo;
